import { ButtonHTMLAttributes } from 'react';
import {
	STANDARD_BUTTON_HORIZONTAL_PADDING_CLASSNAME,
	STANDARD_BUTTON_VERTICAL_PADDING_CLASSNAME,
	STANDARD_BUTTON_TEXT_SIZE_CLASSNAME,
	STANDARD_BUTTON_DISABLED_CLASSNAME,
} from 'src/components/primitives/Button/consts';
import { cm } from 'src/utils/classNames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	label: string;
	isActive: boolean;
}

export default function ToggleTabButton({
	className,
	label,
	isActive,
	...rest
}: Props) {
	return (
		<button
			className={cm(
				'z-10 flex-1 rounded-xs text-text-secondary transition-colors',
				!isActive ? 'hover:text-text-default' : 'text-white',
				STANDARD_BUTTON_HORIZONTAL_PADDING_CLASSNAME.md,
				STANDARD_BUTTON_VERTICAL_PADDING_CLASSNAME.md,
				STANDARD_BUTTON_TEXT_SIZE_CLASSNAME.md,
				STANDARD_BUTTON_DISABLED_CLASSNAME,
				className
			)}
			{...rest}
		>
			{label}
		</button>
	);
}
